import { Content } from 'LegacySBCRA/Content/Content';

import styles from './CarCheckReportError.module.scss';

export const CarCheckReportError = ({ message }: { message: string }) => (
  <Content className={styles.error}>
    <h2>{message}</h2>
  </Content>
);
